import { InternalWorkspace } from "@/types/workspace";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface InternalProjectState {
  currentPage: number;
  nextPageToken: string | null;
  workspaces: InternalWorkspace[];
}

const initialState: InternalProjectState = {
  currentPage: 1,
  nextPageToken: null,
  workspaces: []
};

export const internalWorkspaceSlice = createSlice({
  name: "internalWorkspace",
  initialState,
  reducers: {
    setCurrentPage: (state, action: PayloadAction<number>) => {
      state.currentPage = action.payload;
    },
    setNextPageToken: (state, action: PayloadAction<string | null>) => {
      state.nextPageToken = action.payload;
    },
    setWorkspaces: (state, action: PayloadAction<InternalWorkspace[]>) => {
      state.workspaces = action.payload;
    },
    resetWorkspaceState: (state) => {
      state.currentPage = 1;
      state.nextPageToken = null;
      state.workspaces = [];
    }
  }
});

export const {
  setCurrentPage,
  setNextPageToken,
  setWorkspaces,
  resetWorkspaceState
} = internalWorkspaceSlice.actions;

export default internalWorkspaceSlice.reducer;
